import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'saving-plans-donau-capital-hint',
  imports: [TranslocoPipe],
  templateUrl: './donau-capital-hint.component.html',
})
export class DonauCapitalHintComponent {
  @Input() public hasCryptoAsset = false;
}
